import {
  FactSliderModalController
} from './slider/facts-slider-modal.component';
import {
  setShowSystemKeys,
  getTableViewByType
} from './table-view';
import {
  WSPLITTER,
  IS_IE_BROWSER
} from '../common/config';

require('./facts.component.scss');

// /* global gettext */

class FactsController {
  constructor(
    $scope,
    $timeout,
    $element,
    AudioWavesService,
    AudioService,
    $modal,
    RouterService,
    FieldsModalService,
    LayoutService,
    CurrentModelService,
    CurrentFilterService,
    LocalStorageService,
  ) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    $scope.generateReport = RouterService.generateReport.bind(RouterService);
    $scope.isCollapsed = true;
    $scope.router = RouterService;
    this.dims = CurrentModelService.model._dimensions;
    this.FieldsModalService = FieldsModalService;
    this.CurrentFilterService = CurrentFilterService;
    $scope.setShowSystemKeys = setShowSystemKeys;
    $scope.LayoutService = LayoutService;
    $scope.selectedFact = $scope.filterData.filterData &&
      $scope.filterData.filterData.length ? $scope.filterData.filterData[0] : null;
    if ($scope.selectedFact) {
      $scope.selectedFact.selected = true;
    }

    if (IS_IE_BROWSER) {
      AudioService.loadNextAudio = () => {
        const nextFact = $scope.getNextAudio({
          select: false
        });
        if (nextFact && nextFact.audio && !nextFact.audioLoad) {
          // console.log('load audio', nextFact.audio.src);
          nextFact.audio.load();
          nextFact.audioLoad = true;
        }
      };

      AudioService.playNextAudio = () => {
        const nextFact = $scope.getNextAudio({
          select: true
        });
        if (nextFact && nextFact.audio) {
          AudioService.play(nextFact.audio);
          nextFact.audioLoad = true;
        }
      };
    }


    $scope.$on('factsLoaded', () => {
      if (!$scope.router.needToShowFact) return;
      if ($scope.router.needToShowFact.needShowScreenshot) {
        const res = $scope.router.CurrentFilterDataService.filterData.filterData;
        if (res && res.length) {
          let fact = $scope.router.needToShowFact.fact;
          if (!fact && $scope.router.needToShowFact.date) {
            console.log('data:', $scope.router.needToShowFact.date);
            const date = (new Date($scope.router.needToShowFact.date)).getTime();
            fact = res[0];
            let dateDiff = Math.abs((new Date(fact.local_time)).getTime() - date);
            res.forEach(f => {
              const d = Math.abs((new Date(f.local_time)).getTime() - date);
              if (d < dateDiff) {
                fact = f;
                dateDiff = d;
              }
            });
          } else if (!fact) fact = res[0];

          $scope.showImage(fact);
          delete $scope.router.needToShowFact;

        } else {
          $scope.router.needToShowFact = false;
          $scope.router.modal = null;
        }
      } else if ($scope.router.needToShowFact.needShowtoNeighbours) {
        const fact = $scope.filterData.filterData.find(f => f.id === $scope.router.needToShowFact.fact.id);
        if (!fact) return;
        $scope.LayoutService.loading = true;
        $scope.select(fact);
        this.$timeout(() => {
          $scope.$apply(() => $scope.LayoutService.loading = false);
        }, 100);
        delete $scope.router.needToShowFact;
      }
    });

    $scope.showSelectFields = () => this.CurrentFilterService &&
      this.CurrentFilterService.filter &&
      !this.CurrentFilterService.filter.isDashboard && !this.CurrentFilterService.filter.isCard;

    $scope.selectFields = () => this.FieldsModalService.open('TABLE')
      .then(r => {
        if (r) this.$timeout(() => {
          $scope.filterData.filterData = angular.copy($scope.filterData.filterData);
          this.$timeout(() => $scope.$root.$broadcast('resize'), 0);
        }, 200);
      });

    $scope.getNextAudio = ({
      select
    }) => {
      let eventIndex = $scope.getEventIndex();
      while (eventIndex < $scope.filterData.filterData.length && eventIndex >= 0) {
        eventIndex += 1;
        if (eventIndex + 1 >= $scope.filterData.filterData.length) {
          $scope.more();
        }
        if (eventIndex >= 0) {
          const fact = $scope.filterData.filterData[eventIndex];
          if (fact && fact['agent_eventtype.id'] === 21) {
            if (select) {
              $scope.select(fact);
              $scope.$apply();
            }
            return fact;
          }
        }
      }
    };
    AudioWavesService.loadNextAudio = () => {};

    AudioWavesService.playNextAudio = (previousPlayedFact) => {
      if (previousPlayedFact === this.previousPlayedFact) return;
      this.previousPlayedFact = previousPlayedFact;
      const nextFact = $scope.getNextAudio({
        select: true
      });
      if (nextFact && nextFact.wavesurfer) {
        AudioWavesService.play(nextFact.wavesurfer, 0);
        nextFact.audioLoad = true;
      }
    };

    $scope.select = function(fact) {
      if (fact === $scope.selectedFact) {
        return;
      }

      if ($scope.selectedFact) {
        $scope.selectedFact.selected = false;
      }
      $scope.selectedFact = fact;
      fact.selected = true;
      const position1 = $element.find('#tr' + fact.id).position() || 0;
      const eventTable = $element.find('.fact-table-tbody');
      const current = eventTable.scrollTop();
      const tbody_height = eventTable.height();
      eventTable.animate({
        scrollTop: current + position1.top -
          tbody_height / 3,
      }, 100);
      $scope.$broadcast('showPane2');
    };

    $scope.deselect = () => {
      if ($scope.selectedFact) {
        $scope.selectedFact.selected = false;
        $scope.selectedFact = null;
        $scope.$broadcast('hidePane2');
        $scope.$apply();
      }
    };

    $scope.leaf = step => {
      let eventIndex = $scope.getEventIndex();
      if (eventIndex + step >= $scope.filterData.filterData.length) {
        $scope.more();
      } else {
        eventIndex += step;
        if (eventIndex < 0) eventIndex = 0;
        //                 console.log('eventIndex: ' + eventIndex);
        const fact = $scope.filterData.filterData[eventIndex];
        $scope.select(fact);
        $scope.$apply();
      }
    };
    // $scope.getEventIndex = () => $scope.selectedFact ?
    //   $scope.filterData.filterData.indexOf($scope.selectedFact) : 0;
    $scope.getEventIndex = () => $scope.selectedFact ?
      $scope.filterData.filterData.findIndex(f => $scope.selectedFact.id === f.id) : 0;

    $scope.leafToLast = () => {
      const moveTo = $scope.filterData.filterData && $scope.filterData.filterData.length ?
        $scope.filterData.filterData[$scope.filterData.filterData.length - 1] : null;
      if (moveTo) {
        $scope.select(moveTo);
        $scope.$apply();
      }
    };
    $scope.leafToFirst = () => {
      const moveTo = $scope.filterData.filterData &&
        $scope.filterData.filterData.length ?
        $scope.filterData.filterData[0] : null;
      if (moveTo) {
        $scope.select(moveTo);
        $scope.$apply();
      }
    };

    $scope.openImage = fact => {
      $scope.router.needToShowFact = {
        needShowScreenshot: true,
        fact: fact
      };
      $scope.$root.$broadcast('factsLoaded');
    };

    $scope.openFact = fact => {
      console.log('Hover', this);
    };

    $scope.showImage = fact => {
      if ($scope.router.isFilterEditModal) return;
      $scope.select(fact);
      if ($scope.imageDialog) {
        $scope.imageDialog.close();
      }
      if ($scope.router.imageDialog) {
        $scope.router.imageDialog.close();
      }

      $scope.imageDialog = $modal.open({
        scope: $scope,
        template: require('./slider/facts-slider-modal.component.html'),
        controller: FactSliderModalController,
        windowClass: 'showImageModal',
      });

      $scope.router.CurrentFilterService.modal = null;
      $scope.router.needToShowFact = false;
      $scope.router.imageDialog = $scope.imageDialog;

      $scope.imageDialog.result.catch(coseData => $scope.router.removeModal());
      $scope.imageDialog.result.then(coseData => $scope.router.removeModal());
    };

    $scope.closeDialog = () => {
      if ($scope.imageDialog) {
        $scope.imageDialog.close();
        // $scope.router.removeModal();
      }
    };

    $scope.$watch('viewMode', newVal => {
      $scope.$broadcast('viewModeChanged', newVal);
    });

    const changeViewMode = () => {
      const filter = $scope.filter;
      if (filter) {
        $scope.viewMode = getTableViewByType(
          filter.viewModeType(),
          filter.filters,
          filter.fields,
          this.dims
        );
      }
      if (!$scope.filterData.filterData || !$scope.filterData.filterData.length || !$scope.selectedFact ||
        !~$scope.filterData.filterData.findIndex(f => f.id === $scope.selectedFact.id)) {
        $scope.selectedFact = null;
      }
      if (!$scope.selectedFact) {
        $scope.$broadcast('hidePane2');
      }
    };

    $scope.$watch('filterData.filterData', (newVal, oldVal) => {
      changeViewMode();
    }, false);

    const keyboardEvents = {
      13: function() {
        if ($scope.selectedFact['agent_eventtype.name'] === 'Screenshot') $scope.openImage(
          $scope.selectedFact
        );
        $scope.$apply();
      }, // Enter
      27: function() {}, // Esc
      32: function() {
        $scope.leaf(1);
      }, // Space
      33: function() {
        $scope.leaf(-5);
      }, // PgUp
      34: function() {
        $scope.leaf(5);
      }, // PgDown
      35: function() {
        $scope.leafToLast();
      }, // End
      36: function() {
        $scope.leafToFirst();
      }, // Home
      37: function() {
        $scope.leaf(-1, true);
      }, // Left
      38: function() {
        $scope.leaf(-1);
      }, // Up
      39: function() {
        $scope.leaf(1, true);
      }, // Right
      40: function() {
        $scope.leaf(1);
      } // Down
    };

    $scope.bindEvents = function() {
      $element.off('keydown').on('keydown', e => {
        const code = e.which;
        //                 console.log(code);
        if (code in keyboardEvents) {
          keyboardEvents[code]();
          e.preventDefault();
        }
      });
    };

    $scope.splitter = {
      pos: WSPLITTER
    };
    Object.defineProperty($scope, 'listType', {
      get: () => $scope.filter.listType,
    });
    $scope.more = () => $scope.loadMore && $scope.filterData.moreFacts();

    // const subscriptions = [$scope.filterData.filterData$.subscribe(() => {
    //   $scope.$root.$broadcast('factsLoaded');
    // })];
    // $scope.$on('$destroy', () => subscriptions.forEach((subscription) =>
    //   subscription.dispose()));
  }

  toggleSortOrder(col) {
    if (!col.sortable) return;
    const filter = this.$scope.filter;
    filter.orderDir = filter.orderDir === 'desc' ? 'asc' : 'desc';
    filter.order = col.factKey;
    this.$scope.router.filter = filter;
    // this.$scope.filterData.update(filter);
  }

  isColSorted(col) {
    if (!col.sortable) return false;
    const order = this.$scope.filter.order === 'record_count' ? 'local_time' : this.$scope.filter.order;
    return order === col.factKey;
  }

}

export function FactsComponent(
  $compile,
  $timeout,
  RouterService,
) {
  return {
    restrict: 'E',
    scope: {
      model: '<',
      filter: '<',
      filterData: '<',
      showFactsInfo: '<',
      loadMore: '<',
    },
    template: require('./facts.component.html'),
    controller: FactsController,
    controllerAs: '$ctrl',
    link: function(scope, element, attrs) {
      scope.setShowSystemKeys(scope.LayoutService.options);
      scope.$watch('filter.listType', (newVal, oldVal) => {
        scope.bindEvents();

        // Send event to update table columns
        if (newVal === 'table') {
          $timeout(() => {
            scope.$broadcast('viewModeChanged', scope.viewMode);
          });
        }

        if (newVal === 'table') {
          element.find('.fact-table-tbody').focus();
        } else if (newVal === 'thumblist') {
          element.find('.fact-thumbnail-list').focus();
        }

        element.click('.widget-value', event => {
          const el = angular.element(event.target);
          const closestAttr = (elScope, attr) => {
            while (!elScope[attr] && elScope.$parent) {
              elScope = elScope.$parent;
            }
            return elScope[attr];
          };
          if (el.attr('data-key')) {
            scope.$apply(() => {
              const key = el.attr('data-key');
              if (key === 'agent_web@url:url') {
                return window.open(el.attr('data-value'));
              }
              if (key === 'id@default:id') {
                RouterService.setFilter(key,
                  el.attr('data-value'), el.attr('data-label')
                );
                return;
              }
              // todo when $compileProvider.debugInfoEnabled is set to false,
              // calling .scope() on a DOM node will return undefined
              // const elScope = el.scope().$parent;
              const fact = closestAttr(el.scope(), 'fact');
              const model = closestAttr(el.scope(), 'model');
              if (fact && model) {
                const filter = model.getCellFilter(key, fact);
                RouterService.drilldownFilter2(filter);
              }
              // RouterService.drilldownFilter(filter);
            });
          }
        });
      });
    },
  };
}



// WEBPACK FOOTER //
// ./src/facts/facts.component.js